import { FC, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import Title from '../../components/Title/Title';

import { TRootState } from '../../store/store';
import { transport } from '../../utils/constants';
import { getToken, haptic, Haptick } from '../../utils/helper';
import './Wallet.scss';

import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Deposit from '../../components/Deposit/Deposit';
import Transfer from '../../components/Transfer/Transfer';
import WithDraw from '../../components/WithDraw/WithDraw';

import { default as SwipeModal, default as SwipeModalPublicMethods } from 'react-swipe-modal';
import ControlledInput from '../../components/Common/ControlledInput/ControlledInput';
import Exchange from '../../components/Exchange/Exchange';

import { resetBalance, setLoadingWallet } from '../../store/wallet/wallet.slice';
import { Transactions } from './Components/Transactions/Transactions';
import { WalletService } from './Components/WalletService/WalletService';
import { IAsset } from './types';
import { WalletClient } from '../../generated/mlmbox/client/finance/wallet.client';
import { Empty } from '../../generated/google/protobuf/empty';
import { ExchangerClient } from '../../generated/mlmbox/client/exchanger/exchanger.client';
import AddWallet from '../../components/Web3/AddWallet.tsx';
import { useAppKitAccount, useAppKitProvider } from '@reown/appkit/react';

enum StatusExchange {
    NOT_ENOUGH = 0,
    SUCCESS = 1,
    UNKNOWN = 3,
}

const Wallet: FC = () => {
    const [assetID, setAssetID] = useState(1);
    const [openAmount, setOpenAmount] = useState(false);
    const [mellValue, setMellValue] = useState<string>('');
    const [usdtValue, setUsdtValue] = useState<string>('');

    const wallet = useSelector((state: TRootState) => state.wallet.value);
    const [transfer, setTransfer] = useState(false);
    const [exchange, setExchange] = useState<'buy' | 'sell' | null>(null);
    const wevb3Address = useSelector((state: TRootState) => state.distribution.value?.web3Address);
    const [deposit, setDeposit] = useState<IAsset | null>(null);
    const [withdraw, setWithdraw] = useState<IAsset | null>(null);
    const [reload, setReload] = useState(false);
    const [_, setFetch] = useState(false);
    const dispatch = useDispatch();
    const [visible, setVisible] = useState(true);
    const [drag, setDrag] = useState(false);
    const [updated, setUpdated] = useState(false);
    const { t } = useTranslation();
    const [warningMessage, setWarningMessage] = useState<string | null>(null);

    const [searchParams] = useSearchParams();
    const [assetId, setAssetId] = useState<number>(
        searchParams.get('asset') ? Number(searchParams.get('asset')) + 1 : 1
    );
    const assetIdRef = useRef(assetId);
    const updateAssetId = (newId: number) => {
        assetIdRef.current = newId; // Обновляем ref
        setAssetId(newId); // Обновляем состояние
    };

    useEffect(() => {
        const assetParam = searchParams.get('asset');
        setAssetId(assetParam ? Number(assetParam) + 1 : 1);
    }, [searchParams]);

    const fetchWalletInfo = async () => {
        dispatch(setLoadingWallet({ loading: true }));
        const finance = new WalletClient(transport);

        const { response, status } = await finance.info(Empty, { meta: { authorization: getToken() } });

        if (status.code === 'OK') {
            dispatch(resetBalance(response.assets));
        }
        dispatch(setLoadingWallet({ loading: false }));
    };

    useEffect(() => {
        setFetch(true);
        fetchWalletInfo();
    }, [assetId, dispatch, reload]);

    const exchangeModal = useRef<SwipeModalPublicMethods>(null);

    useEffect(() => {
        if (exchangeModal.current) {
            if (exchange) {
                exchangeModal?.current?.show();
            } else {
                exchangeModal?.current?.close();
                setAssetID(1);
                setUsdtValue('');
                setMellValue('');
            }
        }
    }, [exchangeModal, exchange]);

    function validateExchange(value: string): boolean {
        let result = true;

        console.log(previewExchange(value));

        if (warningMessage) return (result = false);
        if (Number(value) <= 0) {
            setWarningMessage('Сумма не может быть меньше 1');
            setTimeout(() => {
                setWarningMessage(null);
            }, 4000);
            return (result = false);
        }
        if (Number(value) > 100) {
            setWarningMessage('Сумма не может быть больще 100');
            setTimeout(() => {
                setWarningMessage(null);
            }, 4000);
            return (result = false);
        }

        return result;
    }

    async function previewExchange(value: string): Promise<StatusExchange> {
        const exchangerClient = new ExchangerClient(transport);

        let result = StatusExchange.UNKNOWN;

        const { response, status } = await exchangerClient.all(Empty, { meta: { authorization: getToken() } });

        if (status.code === 'OK') {
            response.items.forEach(async (item) => {
                if (item.targetAssetId === assetID) {
                    try {
                        const { status } = await exchangerClient.preview(
                            {
                                sourceAssetId: item.sourceAssetId,
                                targetAssetId: item.targetAssetId,
                                sourceAmount: value,
                            },
                            { meta: { authorization: getToken() } }
                        );

                        if (status.code !== 'OK') {
                            return (result = StatusExchange.NOT_ENOUGH);
                        }
                    } catch (error) {
                        return (result = StatusExchange.NOT_ENOUGH);
                    }
                }
            });
        }

        return result;
    }

    const navigate = useNavigate();
    const { address } = useAppKitAccount();
    const { walletProvider } = useAppKitProvider('eip155');

    const [addWallet, setAddwallet] = useState(false);
    const addWalletModal = useRef<SwipeModalPublicMethods>(null);

    useEffect(() => {
        if (wallet) setAddwallet(false);
    }, [wallet]);

    useEffect(() => {
        if (addWalletModal.current) {
            if (addWallet) {
                addWalletModal?.current?.show();
            } else {
                addWalletModal?.current?.close();
                setAddwallet(false);
            }
        }
    }, [addWalletModal, addWallet]);

    return (
        <>
            {assetId && (
                <div
                    className="wallet"
                    id="section">
                    <Title text={t('wallet.titles.balance')} />
                    <Splide
                        options={{ width: '100%', arrows: false, gap: 20, start: assetId - 1 }}
                        onDrag={() => {
                            setDrag(true);
                        }}
                        onMoved={(e: any) => {
                            console.log(e.index + 1, assetIdRef);
                            if (e.index + 1 === assetIdRef.current) {
                                setDrag(false);
                            } else {
                                updateAssetId(e.index + 1);
                            }
                        }}>
                        {wallet.assets.map((el) => (
                            <SplideSlide key={el.assetId}>
                                <WalletService
                                    setWithdraw={setWithdraw}
                                    setTransfer={setTransfer}
                                    setDeposit={setDeposit}
                                    assetId={el.assetId}
                                    setExchange={setExchange}
                                    setContract={() => {
                                        Haptick(haptic.light);
                                        if (wevb3Address && address && walletProvider) navigate('/contract');
                                        if (!wevb3Address && !addWallet && !walletProvider) setAddwallet(true);
                                        if (wevb3Address && !address && !walletProvider) setAddwallet(true);
                                    }}
                                />
                            </SplideSlide>
                        ))}
                    </Splide>

                    <div className="line"></div>
                    <Title text={t('wallet.titles.history')} />
                    {
                        <div
                            className="tr"
                            // style={{ opacity: !drag ? 1 : 0 }}
                            hidden={drag}>
                            <Transactions
                                reload={reload}
                                setReload={setReload}
                                assetId={assetId}
                                visible={drag}
                                setVisible={setDrag}
                            />
                        </div>
                    }
                    {transfer && (
                        <Transfer
                            setReload={setReload}
                            assetId={assetId}
                            closeBtn={() => setTransfer(false)}
                        />
                    )}
                    {withdraw && (
                        <WithDraw
                            withDrawProcessingAlow={withdraw}
                            setReload={setReload}
                            assetId={assetId}
                            closeBtn={() => setWithdraw(null)}
                        />
                    )}
                    {deposit && (
                        <Deposit
                            deposit={deposit}
                            asseId={assetId}
                            closeBtn={() => setDeposit(null)}
                        />
                    )}
                    {
                        <SwipeModal
                            onClose={() => {
                                setExchange(null);
                            }}
                            modalStyle={{
                                bottom: exchange ? '20px' : 0,
                            }}
                            backdropOpacity={0.8}
                            ref={exchangeModal}>
                            <>
                                <div className="close-modal">
                                    <svg
                                        onClick={() => {
                                            if (exchangeModal.current) exchangeModal.current.close();
                                            setExchange(null);
                                        }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none">
                                        <path
                                            d="M1.17282 12C0.514893 12 0 11.4702 0 10.8115C0 10.4964 0.114414 10.1957 0.343257 9.98084L4.3051 5.99999L0.343257 2.0334C0.114414 1.8043 0 1.51789 0 1.20286C0 0.529821 0.514893 0.0286375 1.17282 0.0286375C1.50178 0.0286375 1.75923 0.143189 1.98807 0.357995L5.97852 4.3389L9.99761 0.343668C10.2407 0.100239 10.4982 0 10.8128 0C11.4707 0 12 0.515509 12 1.17422C12 1.50358 11.8998 1.76133 11.6423 2.01909L7.66626 5.99999L11.6281 9.96661C11.8713 10.1814 11.9856 10.482 11.9856 10.8115C11.9856 11.4702 11.4565 12 10.7842 12C10.4553 12 10.1549 11.8855 9.94034 11.6563L5.97852 7.67544L2.03097 11.6563C1.80214 11.8855 1.50178 12 1.17282 12Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <h1>{exchange === 'buy' ? t('buy') : t('sell')}</h1>
                                {exchange && (
                                    <Exchange
                                        type={exchange}
                                        setMellValue={(value) => setMellValue(value)}
                                        setUsdtValue={(value) => setUsdtValue(value)}
                                        setOpenAmount={() => setOpenAmount(true)}
                                        assetId={exchange === 'buy' ? 1 : 2}
                                        setAssetId={setAssetID}
                                        usdtValue={usdtValue}
                                        mellValue={mellValue}
                                        setExchange={setExchange}
                                        setReload={setReload}
                                    />
                                )}
                            </>
                        </SwipeModal>
                    }
                </div>
            )}

            {openAmount && (
                <ControlledInput
                    close={() => setOpenAmount(false)}
                    setValue={assetID === 1 ? setUsdtValue : setMellValue}
                    setValue2={assetID === 1 ? setMellValue : setUsdtValue}
                    placeholder={t('placeholderExchange', { currency: assetID === 1 ? 'USDT' : '$MOON' })}
                    title={assetID === 1 ? 'USDT' : '$MOON'}
                    typeInput="number"
                    value={assetID === 1 ? usdtValue : mellValue}
                    validate={validateExchange}
                    warningMessage={warningMessage}
                    exchange={true}
                    assetId={assetID}></ControlledInput>
            )}

            {
                <SwipeModal
                    hideBar={true}
                    onClose={() => {
                        setAddwallet(false);
                    }}
                    modalStyle={{
                        bottom: addWallet ? '20px' : 0,
                    }}
                    backdropOpacity={0.8}
                    ref={addWalletModal}>
                    <>
                        <div className="close-modal btn-modal">
                            <svg
                                onClick={() => {
                                    if (addWalletModal.current) addWalletModal.current.close();
                                    setAddwallet(false);
                                }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none">
                                <path
                                    d="M1.17282 12C0.514893 12 0 11.4702 0 10.8115C0 10.4964 0.114414 10.1957 0.343257 9.98084L4.3051 5.99999L0.343257 2.0334C0.114414 1.8043 0 1.51789 0 1.20286C0 0.529821 0.514893 0.0286375 1.17282 0.0286375C1.50178 0.0286375 1.75923 0.143189 1.98807 0.357995L5.97852 4.3389L9.99761 0.343668C10.2407 0.100239 10.4982 0 10.8128 0C11.4707 0 12 0.515509 12 1.17422C12 1.50358 11.8998 1.76133 11.6423 2.01909L7.66626 5.99999L11.6281 9.96661C11.8713 10.1814 11.9856 10.482 11.9856 10.8115C11.9856 11.4702 11.4565 12 10.7842 12C10.4553 12 10.1549 11.8855 9.94034 11.6563L5.97852 7.67544L2.03097 11.6563C1.80214 11.8855 1.50178 12 1.17282 12Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                        <AddWallet />
                    </>
                </SwipeModal>
            }
        </>
    );
};

export default Wallet;
